var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 12.5L20.1641 17.5M20.1641 12.5L15.1641 17.5M20.6641 6.5H0.664062M20.6641 8.5V4.7C20.6641 3.5799 20.6641 3.01984 20.4461 2.59202C20.2543 2.2157 19.9484 1.90974 19.572 1.71799C19.1442 1.5 18.5842 1.5 17.4641 1.5H3.86406C2.74396 1.5 2.18391 1.5 1.75608 1.71799C1.37976 1.90973 1.0738 2.21569 0.88205 2.59202C0.664062 3.01984 0.664062 3.5799 0.664062 4.7V12.3C0.664062 13.4201 0.664062 13.9802 0.88205 14.408C1.0738 14.7843 1.37976 15.0903 1.75608 15.282C2.18391 15.5 2.74396 15.5 3.86406 15.5H10.6641",
    stroke: "#610D24",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedIcon);
export default __webpack_public_path__ + "static/media/reserved_icon.ac5988db2131aa456dd90db400267c9e.svg";
export { ForwardRef as ReactComponent };